









































import Vue from 'vue'
import { mapState } from 'vuex'
import { Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import InitLoader from '@/components/Misc/InitLoader.vue'
import TopContainer from '@/components/TopContainer.vue'
import DidIframeListeners from '@/components/DidIframeListeners.vue'
import BottomContainer from '@/components/BottomContainer.vue'
import IdentifyWizard from '@/components/IdentifyWizard/IdentifyWizard.vue'
import UserOverview from '@/components/UserOverview.vue'
import ShippingAddress from '@/components/ShippingAddress.vue'
import EditUser from '@/components/EditUser.vue'
import Notice from '@/components/Misc/Notice.vue'
import JavascriptAPI from '@/utils/JavascriptAPI'
import { setThemeVariables } from '@/utils/setup'
import { ContextState, User, Config } from '@/store/context/contextTypes'
import { ThemeState } from '@/store/theme/themeTypes'

// Vuex + typescript setup guide: https://codeburst.io/vuex-and-typescript-3427ba78cfa8

// define the module
const _CONTEXT_: string = 'context'
const _THEME_: string = 'theme'

@Component({
  computed: {
    ...mapState({
      initLoading: (state: any): User => state.context.initLoading,
      user: (state: any): User => state.context.user,
      userWizardData: (state: any): User => state.context.userWizardData,
      customShippingAddress: (state: any): Boolean => state.context.customShippingAddress,
      config: (state: any): object => state.context.config,
      errors: (state: any): object => state.context.errors,
      wizardIdentifyProvider: (state: any): boolean => state.context.wizardIdentifyProvider
    })
  },
  components: {
    InitLoader,
    TopContainer,
    DidIframeListeners,
    BottomContainer,
    IdentifyWizard,
    UserOverview,
    EditUser,
    ShippingAddress,
    Notice
  },
  watch: {
    initLoading (loading) {
      JavascriptAPI.__CALLBACK_INIT_LOAD__()
    }
  }
})

export default class Checkout extends Vue {
  title!: string
  user!: User
  errors!: any
  customShippingAddress!: Boolean
  config!: Config
  rememberMe: boolean
  @Action('setTheme', { namespace: _THEME_ }) setTheme: any
  @Action('setEditUser', { namespace: 'context' }) setEditUser: any
  @Action('resetErrors', { namespace: 'context' }) resetErrors: any
  @Getter('theme', { namespace: _THEME_ }) themeConfig: ThemeState
  @Getter('identifiedUser', { namespace: _CONTEXT_ }) identifiedUser: User

  async mounted () {
    JavascriptAPI.__REPORT_CLIENT_HEIGHT__()
  }

  get showWizard (): boolean {
    const { identifyFields, country } = this.config
    return identifyFields !== undefined && country !== '' && !this.user
  }

  get showCustomShippingAddress (): boolean {
    const { editUser } = this.config
    return this.customShippingAddress && (this.identifiedUser !== undefined || editUser)
  }
}
